module.exports = __webpack_public_path__ + "static/media/CardActionEditIcon.c86c43b1.svg";